import { Locale } from "./types";

export { pathnames } from "@/features/routing/pathnames.generated";

export const locales = ["en", "es"] as const;

export const localeItems = [
  {
    value: "en",
    label: "English",
  },
  {
    value: "es",
    label: "Español",
  },
];

export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";

export const defaultLocale: Locale = "es";
